import { Component } from '@angular/core';

@Component({
  selector: 'pt-aside',
  templateUrl: './aside.component.html',
  styleUrls: ['./aside.component.scss']
})
export class AsideComponent {}
